import { render, staticRenderFns } from "./ProgramProgramModuleView.vue?vue&type=template&id=4380f26e"
import script from "./ProgramProgramModuleView.vue?vue&type=script&lang=js"
export * from "./ProgramProgramModuleView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports